import { BaseEdge, EdgeLabelRenderer, useInternalNode } from '@xyflow/react'
import React, { useMemo } from 'react'

import PropTypes from 'prop-types'
import { getEdgeParams, getHandleCoordsById } from '../utils/getEdgeParams'
import { useEntityGraphContext } from '../../Wrapper/EntityGraphProvider'
import { getEdgePath } from '../utils/getEdgePath'

function FloatingEdge ({ data: edgeData, labelStyle: _labelStyle, source, target, markerEnd, markerStart, targetHandleId, sourceHandleId, interactionWidth }) {
  const { state: { config } } = useEntityGraphContext()

  const style = useMemo(() => edgeData?.style ?? undefined, [edgeData])
  const labelStyle = useMemo(() => edgeData?.labelStyle ?? _labelStyle ?? {}, [_labelStyle, edgeData?.labelStyle])

  const pathType = useMemo(() => config?.canvasSettings?.pathType ?? 'smoothstep', [config?.canvasSettings?.pathType])
  const sourceNode = useInternalNode(source)
  const targetNode = useInternalNode(target)

  const { sx, sy, tx, ty, sourcePos, targetPos } = useMemo(() => getEdgeParams(
    sourceNode,
    targetNode
  ), [sourceNode, targetNode])

  const [targetHandleX, targetHandleY] = useMemo(() =>
    targetHandleId ? getHandleCoordsById(targetNode, targetHandleId) : [null, null],
  [targetNode, targetHandleId])

  const [sourceHandleX, sourceHandleY] = useMemo(() =>
    sourceHandleId ? getHandleCoordsById(sourceNode, sourceHandleId, 'source') : [null, null],
  [sourceNode, sourceHandleId])

  const [edgePath, labelX, labelY] = useMemo(() => getEdgePath({
    sourceX: sourceHandleX ?? sx,
    sourceY: sourceHandleY ?? sy,
    sourcePosition: sourcePos,
    targetPosition: targetPos,
    targetX: targetHandleX ?? tx,
    targetY: targetHandleY ?? ty
  }, pathType)
  , [sourceHandleX, sx, sourceHandleY, sy, sourcePos, targetPos, targetHandleX, tx, targetHandleY, ty, pathType])

  if (!sourceNode || !targetNode) {
    return null
  }

  return (
    <>
      <BaseEdge
        path={edgePath}
        style={style}
        markerEnd={markerEnd}
        markerStart={markerStart}
        interactionWidth={interactionWidth}
      />
      {edgeData?.label?.length && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              background: '#fff',
              padding: 10,
              borderRadius: 5,
              fontSize: 12,
              fontWeight: 700,
              ...labelStyle
            }}
            className='nodrag nopan'
          >
            {edgeData?.label}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  )
}
FloatingEdge.propTypes = {
  data: PropTypes.shape({
    style: PropTypes.object,
    label: PropTypes.string,
    labelStyle: PropTypes.object
  }),
  source: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  markerEnd: PropTypes.string,
  markerStart: PropTypes.string,
  targetHandleId: PropTypes.string,
  sourceHandleId: PropTypes.string,
  interactionWidth: PropTypes.number,
  labelStyle: PropTypes.object
}

export default FloatingEdge
